var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./fit-info-text.j2"] = require( "./fit-info-text.j2" );
dependencies["./measurement-unit-select.j2"] = require( "./measurement-unit-select.j2" );
dependencies["./fit-size-guide.j2"] = require( "./fit-size-guide.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/fit-select.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.fits",[]]));
frame.set("availableFits", t_1, true);
if(frame.topLevel) {
context.setVariable("availableFits", t_1);
}
if(frame.topLevel) {
context.addExport("availableFits", t_1);
}
output += "\n\n";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "availableFits")) > 1) {
output += "\n    <div class=\"o-row c-size-guide__fit\" role=\"tablist\">\n        ";
frame = frame.push();
var t_4 = runtime.contextOrFrameLookup(context, frame, "availableFits");
if(t_4) {var t_3 = t_4.length;
for(var t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2];
frame.set("fit", t_5);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += "\n            ";
var t_6;
t_6 = Math.floor(12 / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"length"));
frame.set("columnWidth", t_6, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_6);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_6);
}
output += "\n\n            <div class=\"o-extra-small--4 o-medium--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "columnWidth"), env.opts.autoescape);
output += " u-no-gutters\">\n                <button class=\"c-size-guide__fit-button js-fit-select ";
output += runtime.suppressValue((runtime.memberLookup((t_5),"slug") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedFit")),"slug")?"is-selected":""), env.opts.autoescape);
output += "\" name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"displayName"), env.opts.autoescape);
output += "\"value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"slug"), env.opts.autoescape);
output += "\" role=\"tab\">\n                \t";
output += runtime.suppressValue(runtime.memberLookup((t_5),"displayName"), env.opts.autoescape);
output += "\n                </button>\n            </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n";
;
}
output += "\n\n";
env.getTemplate("./fit-info-text.j2", false, "product/templates/size-guide/fit-select.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n";
env.getTemplate("./measurement-unit-select.j2", false, "product/templates/size-guide/fit-select.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n";
env.getTemplate("./fit-size-guide.j2", false, "product/templates/size-guide/fit-select.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/fit-select.j2"] , dependencies)